import React, { useState } from "react";
import {
  Box,
  Button,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Link } from "react-router-dom";
import { FaPencilAlt, FaTrashAlt } from "react-icons/fa";
import CustomPopper from "../../../helper/CustomPopper";
import { useDispatch } from "react-redux";
import CustomModal from "../../common/custom-modal";
import { setOpen } from "../../../Redux/ModalReducer";
import Data from "../../common/custom-modal/Data";

const DataTable = ({ data, handleShow }) => {
  const [openSubTable, setOpenSubTable] = useState(false);

  return (
    <>
      <TableRow>

        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpenSubTable(!openSubTable)}
          >
            {openSubTable ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell align="center" component="th" scope="row">
          {data?.offer_id}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {data?.title}
        </TableCell>
        <TableCell align="center">
          <Data data={data?.note} />
        </TableCell>
        <TableCell align="center">{data?.total_price}</TableCell>
        <TableCell align="center">
          {data?.discount} {data?.discount_type}
        </TableCell>
        <TableCell align="center">{data?.final_price}</TableCell>
        <TableCell align="center">
          <span
            className={`badge text-darkTextColor ${data?.active ? "bg-[#28a745]" : "bg-[#ff6877]"
              }`}
          >
            {data?.active ? "active" : "not active"}
          </span>
        </TableCell>
        <TableCell align="center">
          <div className="flex gap-x-10 text-lg items-center justify-center">
            <Link
              to={`/Offers/Edit/${data?.offer_id}`}
              color="inherit"
              underline="none"
            >
              <FaPencilAlt className="text-[#6c757d]" />
            </Link>
            <FaTrashAlt
              onClick={() => {
                handleShow(data?.offer_id);
              }}
              className="text-[#d9534f] cursor-pointer"
            />
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
          <Collapse in={openSubTable} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1, width: "100%" }}>
              <Typography variant="h6" gutterBottom component="div">
                Details:
              </Typography>
              {data?.offerDetails.length > 0 ? (
                <Table size="large" aria-label="details">
                  <TableHead>
                    <TableRow>
                      <th className="p-3 w-3 whitespace-nowrap  text-center  border-b-[1px]">
                        Service
                      </th>
                      <th className="p-3 w-3 whitespace-nowrap  text-center  border-b-[1px]">
                        Days
                      </th>
                      <th className="p-3 w-3 whitespace-nowrap  text-center  border-b-[1px]">
                        Count ticket
                      </th>
                      <th className="p-3 w-3 whitespace-nowrap  text-center  border-b-[1px]">
                        Description
                      </th>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.offerDetails.map((type) => (
                      <TableRow key={type.id}>
                        <TableCell align="center">{type.ourService}</TableCell>
                        <TableCell align="center">{type.days}</TableCell>
                        <TableCell align="center">
                          {type.count_ticket}
                        </TableCell>

                        <TableCell align="center">
                          <Data
                            data={type?.descriptionOffer || type?.description}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography>No Details available</Typography>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default DataTable;
